import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions, db } from "../firebase/config";
import { doc, getDoc } from "firebase/firestore";

const SendNotificationButton = () => {
  const [uid, setUid] = useState("");
  const [title, setTitle] = useState("Test Notification");
  const [body, setBody] = useState("This is a test FCM push message.");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleSend = async () => {
    if (!uid) {
      setStatus("❌ Please enter a valid UID.");
      return;
    }

    setLoading(true);
    setStatus("");
    try {
      // Fetch the FCM token for the given UID from Firestore
      const tokenDoc = await getDoc(doc(db, "fcm_tokens", uid));
      if (!tokenDoc.exists()) {
        setStatus("❌ No FCM token found for this UID.");
        setLoading(false);
        return;
      }
      const token = tokenDoc.data().token;
      if (!token) {
        setStatus("❌ Token document found, but no token present.");
        setLoading(false);
        return;
      }
      const sendNotification = httpsCallable(functions, "sendCustomNotification");
      const res = await sendNotification({ token, title, body });
      if (res.data.success) {
        setStatus("✅ Notification sent successfully!");
      }
    } catch (err) {
      console.error("Notification error:", err);
      setStatus("❌ Failed to send notification.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-4 rounded shadow border border-gray-200">
      <h3 className="font-semibold text-green-700 mb-2">🔔 Send Test Notification</h3>
      <input
        className="border px-2 py-1 w-full mb-2"
        placeholder="Enter User UID"
        value={uid}
        onChange={(e) => setUid(e.target.value)}
      />
      <input
        className="border px-2 py-1 w-full mb-2"
        placeholder="Notification Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
      <textarea
        className="border px-2 py-1 w-full mb-2"
        placeholder="Notification Body"
        value={body}
        onChange={(e) => setBody(e.target.value)}
      />
      <button
        onClick={handleSend}
        className="bg-blue-600 text-white px-4 py-2 rounded w-full"
        disabled={loading}
      >
        {loading ? "Sending..." : "Send Notification"}
      </button>
      {status && <p className="mt-2 text-sm">{status}</p>}
    </div>
  );
};

export default SendNotificationButton;
